import { get, writable } from 'svelte/store';
import { navigate } from '../../app.logic';
import { ChallengeTaskService } from '../../services/challenge-task.service';
export const loading = writable(false);
export const currentChallengeId = writable(0);
export const filter = writable({ criteria: {} });
export const records = writable([]);
export const pagination = writable(null);
export const record = writable(null);
export async function initList(challengeId) {
    currentChallengeId.set(challengeId);
    filter.set({ criteria: { challengeId }, params: null, sorting: "" });
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    record.set(null);
    await load();
}
export async function initDetail(challengeId, oid) {
    record.set(null);
    currentChallengeId.set(challengeId);
    if (oid == 0) {
        record.set({ oid: 0, sample: 0, input: '', output: '', points: 0, order: 0, challengeId: challengeId });
    }
    else {
        let _resp = await ChallengeTaskService.fetchChallengeTask(oid);
        record.set(_resp.payload);
    }
}
export async function search() {
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    await load();
}
export async function load() {
    loading.set(true);
    try {
        let _filter = get(filter);
        let _pag = get(pagination);
        let _resp = await ChallengeTaskService.getChallengeTasks(_filter, _pag.currentPage);
        records.set(_resp.payload);
        pagination.set(_resp.pagination);
    }
    finally {
        loading.set(false);
    }
}
export function onCreate() {
    // console.log("onCreate");
    navigate(`/challenge/${get(currentChallengeId)}/tasks/0`);
}
export function onEdit(item) {
    // console.log("onEdit", item);
    navigate(`/challenge/${get(currentChallengeId)}/tasks/${item.oid}`);
}
export async function save() {
    let _record = get(record);
    return await ChallengeTaskService.saveChallengeTask(_record);
}
export async function onDelete(item) {
    // console.log("onDelete", item);
    await ChallengeTaskService.deleteChallengeTask(item.oid);
    await load();
}
export function onPageChange(pageNumber) {
    // console.log("onPageChange: " + pageNumber);
    pagination.set(Object.assign(Object.assign({}, get(pagination)), { currentPage: pageNumber }));
    load();
}
